import { suggestedDecimals } from "./prices"

export const truncateNumbers = (value: number, maxDecimalDigits: number) => {
	if (value.toString().includes('.')) {
		const parts = value.toString().split('.')
		return parts[0] + '.' + parts[1].slice(0, maxDecimalDigits)
	}
	return value.toString()
}

const INVALID_NUMERIC_CHARS = ['-', '+', 'e']

export const isInvalidNumber = (key: string) => INVALID_NUMERIC_CHARS.includes(key)

export const floorNumber = (num: number, decimals?: number) => {
	const precision = 10 ** (decimals ?? suggestedDecimals(num))
	return Math.floor(num * precision) / precision
}

export const diffPercent = (a: number, b: number) => {
	if (a === b) {
		return 0
	}
	return Math.abs((a - b) / b)
}